<template>
  <div class="type-filter" v-if="visible">
    <ul>
      <li :class="{'selected' : selected('euvia')}" v-on:click="toggle('euvia')"><span>TV-Angebote</span> <span
          class="close-icon" v-if="selected('euvia')"></span>
      </li>
      <li :class="{'selected' : selected('video')}" v-on:click="toggle('video')"><span>Videos</span> <span
          class="close-icon" v-if="selected('video')"></span>
      </li>
    </ul>
  </div>
</template>

<script>
import SearchObject from "../SearchObject";

export default {
  name: 'TypeFilter',
  data: () => {
    return {
      searchObj: new SearchObject(),
      visible: true,
    }
  },
  components: {},
  computed: {},
  created() {
    // hide filter depending to user selection in suggest dropdown
    if (this.searchObj.hideTypeFilter) {
      this.visible = false;
    }
  },
  methods: {
    toggle(type) {
      let index = this.searchObj.Type.indexOf(type);

      if (index === -1) {
        this.searchObj.Type.push(type);
      } else {
        this.searchObj.Type.splice(index, 1);
      }

      document.getElementById('search-progress').classList.add('d-table');
      setTimeout(() => document.forms.vuesearch.submit(), 250)
    },
    selected(type) {
      return this.searchObj.Type.includes(type);
    }

  }
}
</script>

<style lang="scss">

</style>